// extracted by mini-css-extract-plugin
module.exports = {"container":"UnreadMessagesBadge_container__PrXTw","badge":"UnreadMessagesBadge_badge__Xolau"};